/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Error from "../../Error/Index";
import { myHeaders } from "../../../config/axios";
import { URL_API } from "../../../config/default";
import { Modal } from "flowbite-react";
import Banners from "./Tabs/Banners";
import SinDatos from "./Tabs/SinDatos";
import busca from "../../../assets/buscar.svg";
import imagen from "../../../assets/img/fotos.png";
import { CustomToast } from "../../../utils/custom-toast";

const Ajustes = () => {
  const [banner, setBanner] = useState<any>({
    id: null,
    url: "",
    file: null,
    name: "",
    link: "",
    location: null,
  });
  const [modalBanner, setModalBanner] = useState(false);
  const [filterBanner, setFilterBanner] = useState<any>({});

  const estados = [
    { name: "Pausado", value: "pausado" },
    { name: "Activo", value: "activo" },
  ];

  const onChange = (e: any) => {
    switch (e.target.name) {
      case "images":
        {
          const file = e.target.files[0];
          if (file.size > 10000000) {
            return CustomToast({
              status: 400,
              title: "La imagen paso el limite de peso",
            });
          } else {
            setBanner({
              ...banner,
              file: file,
              url: URL.createObjectURL(file),
            });
          }
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: any) => {
    switch (e.target.name) {
      case "guardar":
        {
          const formdata = new FormData();
          formdata.append("file[" + 0 + "]", banner.file);
          formdata.append("name", banner.name);
          formdata.append("link", banner.link);
          formdata.append("location", banner.location);
          formdata.append("status", "activo");

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/banners/upload`, requestOptions)
            .then(async () => {
              CustomToast({
                status: 200,
                msg: "",
                title: "Banner creada con exito",
              });
              setBanner({
                id: null,
                url: "",
                file: null,
                name: "",
                link: "",
                location: null,
              });
              return setModalBanner(false);
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      case "editar":
        {
          const formdata = new FormData();
          formdata.append("file[" + 0 + "]", banner.file);
          formdata.append("name", banner.name);
          formdata.append("link", banner.link);
          formdata.append("location", banner.location);
          formdata.append("status", "activo");

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/banners/${banner.id}`, requestOptions)
            .then(async () => {
              CustomToast({
                status: 200,
                msg: "",
                title: "Banner creada con exito",
              });
              setBanner({
                id: null,
                url: "",
                file: null,
                name: "",
                link: "",
                location: null,
              });
              return setModalBanner(false);
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;

      default:
        break;
    }
  };

  const { isPending, error, data } = useQuery({
    queryKey: ["index-banners", filterBanner],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      const params = new URLSearchParams(filterBanner);

      return fetch(`${URL_API}/banners?${params}`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) return "";

  if (error) return <Error />;

  return (
    <div className="mx-auto md:w-[80%] w-full py-5 min-h-screen px-3">
      <span className="text-primary font-bold text-2xl block my-5">
        Ajuste de baner publicitario
      </span>

      <div className="w-full mb-4 grid grid-cols-1 lg:grid-cols-3">
        <div className="me-2 mb-3 px-3">
          <div
            className="w-full flex items-center bg-white rounded-[20px] shadow "
            style={{ position: "relative" }}
          >
            <label className="cursor-pointer bg-primary rounded-full hover:w-[120px] w-[45px]  h-[40px] flex justify-center items-center group transition duration-500">
              <img
                className="translate-x-7 group-hover:translate-x-0 group-hover:ms-1 group-hover:opacity-100 group-hover:scale-100 transition-all duration-500 text-white font-bold "
                src={busca}
                alt="buscar"
                width={20}
              />
              <span className="opacity-0  transition-[opacity,transform] duration-0 ease-in group-hover:opacity-100 group-hover:scale-100 group-hover:duration-500 text-white font-bold ms-1">
                Buscar
              </span>

              <button className="hidden" onClick={() => ""}></button>
            </label>
            <div className="pt-1">
              <input
                placeholder="Busca por ubicación"
                className="pl-1 border-0 h-[40px] outline-none"
                onChange={(e) =>
                  setFilterBanner({ ...filterBanner, location: e.target.value })
                }
              ></input>
            </div>
          </div>
        </div>

        <div className="mb-3 px-3">
          <select
            id="options"
            className="w-full h-[50px] flex items-center bg-white rounded-[20px] shadow border-0 me-2"
            onClick={(e: any) => {
              if (e.target?.value !== "") {
                setFilterBanner({ ...filterBanner, status: e.target?.value });
              } else {
                setFilterBanner({ ...filterBanner, status: "" });
              }
            }}
          >
            {estados.map((estado) => {
              return (
                <option value={String(estado.value)}>{estado.name}</option>
              );
            })}
          </select>
        </div>

        <div className="w-full flex justify-end mb-3 px-3">
          <label className="cursor-pointer w-full flex justify-center items-center bg-primary text-white px-4 py-2 rounded-xl hover:opacity-[0.9] transition duration-500 me-2 font-semibold  w-[300px]">
            <i className="bi bi-plus-lg me-1"></i>
            Publica un nuevo banner
            <button
              className="hidden"
              onClick={() => setModalBanner(true)}
            ></button>
          </label>
        </div>
      </div>

      <div id="default-tab-content">
        {data?.data.length > 0 ? (
          <Banners
            data={data}
            setBanner={setBanner}
            setModal={setModalBanner}
          />
        ) : (
          <SinDatos />
        )}
      </div>

      <Modal
        className={`animate-fadeIn`}
        dismissible
        show={modalBanner}
        onClose={() => setModalBanner(false)}
      >
        <div className={` ${modalBanner ? "translate-y-0" : "-translate-y-4"}`}>
          <Modal.Header className="text-center w-full h-[0px]"></Modal.Header>

          <Modal.Body className="mb-3 min-h-full">
            <div className="font-bold text-md text-center py-2 text-primary">
              {`${banner.id ? "Editar Banner" : "Agregar Banner"}`}
            </div>

            <div className="lg:p-[50px]">
              <div className="mb-3">
                <span className="font-bold text-black mb-2 block">
                  Agregá alguna imagen
                </span>
                <div className="grid grid-cols-1 gap-5">
                  <span>Comienza colocando un banner personalizado.</span>

                  <label
                    className="border-dashed px-5 py-5 border border-black items-center "
                    style={{
                      width: "100%",
                      height: "300px",
                      backgroundImage: `url(${
                        banner.url ? banner.url : imagen
                      })`,
                      backgroundSize: `${banner.url ? "cover" : "contain"}`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <div className="text-center my-4">
                      <span className="block font-bold">
                        Seleccioná por lo menos 1 imagen
                      </span>
                      <span className="border border-black border-s-0 border-t-0 border-e-0">
                        Subilas desde tu dispositivo
                      </span>
                    </div>
                    <input
                      className="hidden"
                      type="file"
                      name="images"
                      onChange={(event) => onChange(event)}
                      multiple
                    />
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <input
                  name="name"
                  type="text"
                  placeholder="Nombre"
                  className="mb-2 rounded border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600
                   focus:border-primary-600 block w-full p-2.5 placeholder:text-gray-500 placeholder:font-bold"
                  value={banner.name}
                  onChange={(e) =>
                    setBanner({ ...banner, name: e.target.value })
                  }
                />
              </div>
              <div className="mb-3">
                <input
                  name="link"
                  type="text"
                  placeholder="Link"
                  className="mb-2 rounded border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600
                   focus:border-primary-600 block w-full p-2.5 placeholder:text-gray-500 placeholder:font-bold"
                  value={banner.link}
                  onChange={(e) =>
                    setBanner({ ...banner, link: e.target.value })
                  }
                />
              </div>
              <div className="mb-3">
                <select
                  className="mb-2 rounded border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600
                   focus:border-primary-600 block w-full p-2.5 placeholder:text-gray-500 placeholder:font-bold"
                  onChange={(e) =>
                    setBanner({ ...banner, location: e.target.value })
                  }
                >
                  <option value=""></option>
                  {[
                    {
                      name: "Banner - Alquiler",
                      value: "banner-home-alquiler",
                    },
                    {
                      name: "Banner - Excursion",
                      value: "banner-home-excursion",
                    },
                  ].map((ban, index) => {
                    if (ban.value == banner.location) {
                      return <option selected>{ban.name}</option>;
                    }
                    return (
                      <option key={index} value={ban.value}>
                        {ban.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <label className="cursor-pointer btn bg-primary text-white font-bold w-full block text-center py-3 rounded-xl text-xl hover:opacity-[0.9] transition-transform duration-300">
                {`${banner.id ? "Guardar cambios" : "Continuar"}`}
                <button
                  className="hidden"
                  name={`${banner.id ? "editar" : "guardar"}`}
                  onClick={(e) => onClick(e)}
                ></button>
              </label>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="grid grid-cols-3 md:grid-cols-1 gap-3 w-full px-[40px] mb-3 "></div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

export default Ajustes;
